import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LoadingphaseService } from '../../../nav/service/loadingphase.service';

@Component({
   selector: 'app-loading-popup',
   templateUrl: './loading-popup.component.html',
   styleUrls: ['./loading-popup.component.scss']
})
export class LoadingPopupComponent implements OnInit, OnChanges {

   // open state
   // private _visibility = false;
   private _duration = 0;

   // input
   @Input('open') _visibility = false;
   @Input('diameter') _diameter = 50;
   @Input('message') _message = '';
   @Input() scope: string;

   constructor(
       private loadingphaseService: LoadingphaseService
   ) { }

   ngOnInit() {
       if (this.scope) {
        this.loadingphaseService
            .getLoadingEventEmitter(this.scope)
            .subscribe(this.onLoadingChanged.bind(this));
       }
   }

   ngOnChanges(changes: SimpleChanges) {
    const scope = changes.scope;
    if (scope.previousValue) {
    this.loadingphaseService
        .getLoadingEventEmitter(scope.previousValue)
        .unsubscribe();
    }
    if (scope.currentValue) {
    this.loadingphaseService
        .getLoadingEventEmitter(scope.currentValue)
        .subscribe(this.onLoadingChanged.bind(this));
    }
   }

   public showView(
      message: string = '',
      duration: number = 0
   ) {
      if (message !== '' ) {
         this._message = message;
      }
      this._visibility = true;
      if (duration > 0 ) {
         this._duration = duration;
         this.autoHideView();
      }
   }

   public hideView(): void {
      this._visibility = false;
   }

   private autoHideView(): void {
      if (this._duration <= 0) {
         return;
      }
      setTimeout(function () {
         this._visibility = false;
      }.bind(this), this._duration);
   }

   private onLoadingChanged(state: boolean) {
       this._visibility = state;
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/loading-popup/loading-popup.component.ts